import { Platform } from "react-native";

export function getNativeDriver(value: boolean) {
  return {
    useNativeDriver: Platform.select({ web: false, default: value }),
  };
}
